/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductResume
 */
export interface ProductResume {
    /**
     * 
     * @type {string}
     * @memberof ProductResume
     */
    batch?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResume
     */
    materialCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResume
     */
    qty?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResume
     */
    serialNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductResume
     */
    uom?: string;
}

/**
 * Check if a given object implements the ProductResume interface.
 */
export function instanceOfProductResume(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductResumeFromJSON(json: any): ProductResume {
    return ProductResumeFromJSONTyped(json, false);
}

export function ProductResumeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductResume {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batch': !exists(json, 'batch') ? undefined : json['batch'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'serialNumber': !exists(json, 'serialNumber') ? undefined : json['serialNumber'],
        'uom': !exists(json, 'uom') ? undefined : json['uom'],
    };
}

export function ProductResumeToJSON(value?: ProductResume | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch': value.batch,
        'materialCode': value.materialCode,
        'qty': value.qty,
        'serialNumber': value.serialNumber,
        'uom': value.uom,
    };
}

